import { useTranslation } from "react-i18next";
import { setModalsData, TModalsState } from "../api/store/commonSlice";
import svgIcons from "../assets/svg/svgIcons";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import React from "react";

interface SortColumnsButtonProps {
  additionalClasses?: string;
  disabled?: boolean;
  onClick: () => void;
  positioningClasses?: string;
  roundedSize?: string;
  sizeShapeClasses?: string;
}

export const SortColumnsButton = ({
  additionalClasses = "",
  disabled = false,
  onClick,
  positioningClasses = "absolute top-5 right-16 me-2",
  roundedSize = "full",
  sizeShapeClasses = "p-2",
}: SortColumnsButtonProps) => {
  const { t } = useTranslation();

  const [showText, setShowText] = React.useState(false);

  return (
    <button
      className={`${positioningClasses} flex items-center justify-center hover:flex-row ${showText ? `rounded-e-${roundedSize} z-listing-table-header-icons-showtext` : `rounded-${roundedSize} z-listing-table-header-icons`} ${sizeShapeClasses} bg-accent-blue-pale ${disabled ? "opacity-50 grayscale pointer-events-none touch-none" : ""} ${additionalClasses}`}
      onClick={onClick}
      onMouseEnter={() => setShowText(true)}
      onMouseLeave={() => setShowText(false)}
    >
      {showText && (
        <span
          className={`absolute h-full right-full top-0 text-sm font-semibold rounded-s-${roundedSize} ps-4 flex items-center leading-6 bg-accent-blue-pale whitespace-nowrap`}
        >
          {t("admins.edit_columns.sort_columns")}
        </span>
      )}
      <img src={svgIcons.SortColumnsIcon} alt="sort columns" />
    </button>
  );
};
export default SortColumnsButton;
